import type { TValidatorFunction } from '@atlassian/eoc-common';

import { messages as commonMessages } from '../common/messages';

export const getSafe = <Return, FallbackReturn extends Return | null | undefined>(
	fn: () => Return,
	defaultValue: FallbackReturn,
): Return | FallbackReturn => {
	try {
		return fn();
	} catch {
		return defaultValue;
	}
};

type Empty = null | undefined | Record<string, never> | [];

export const isEmpty = (input: unknown): input is Empty => {
	if (input !== 0 && input !== false && !input) {
		return true;
	}
	if (
		!(input instanceof Date) &&
		typeof input === 'object' &&
		Object.keys(input as Object).length === 0
	) {
		return true;
	}
	return false;
};

export const isNullOrUndefined = (input: unknown): input is null | undefined => {
	return input === null || input === undefined;
};

export const noLeadingOrTrailingSpaces =
	(message?: string): TValidatorFunction<any> =>
	({ formatMessage }) =>
	(value) => {
		if (typeof value === 'string' && (value.startsWith(' ') || value.endsWith(' '))) {
			return message ?? formatMessage(commonMessages.nameSpaceValidationError);
		}
	};
